import { IconContactCS } from "@assets/icons";
import { openContactLinksDialog } from "@components/layouts/ContactLinksDialog/utils";
import useContactLinks from "@hooks/useContactLinks";
import { Button } from "kz-ui-sdk";

const ContactButtonGroup = () => {
  const { contactLinks, groupedContactIcon } = useContactLinks();

  if (!contactLinks?.length) {
    return null;
  }

  // If there's only one contact link, render a single button
  if (contactLinks.length === 1) {
    const contact = contactLinks[0];
    return (
      <a
        href={contact.url}
        target={"_blank"}
        rel={"noreferrer noopener"}
      >
        <ContactButton
          image={contact.image}
          description={contact.description}
        />
      </a>
    );
  }

  // If there are multiple contact links
  return (
    <>
      <ContactButton
        image={groupedContactIcon}
        onClick={() => openContactLinksDialog()}
      />
    </>
  );
};

export default ContactButtonGroup;

interface ContactButtonProps {
  image?: string;
  description?: string;
  onClick?: () => void;
}

export const ContactButton = ({ image, description, onClick }: ContactButtonProps) => {
  if (!image) {
    return (
      <Button
        className="flex !h-[30px] !w-[36px] shrink-0 items-center justify-center !rounded !border-none !bg-darkBrand-700 px-1.5"
        onClick={onClick}
        variant="bordered"
      >
        <IconContactCS className="h-6 w-6 text-content-base" />
      </Button>
    );
  }

  return (
    <Button
      className="flex !h-[30px] !w-[36px] shrink-0 items-center justify-center overflow-hidden !rounded !border-none !bg-darkBrand-900"
      onClick={onClick}
      variant="bordered"
    >
      <img
        src={image}
        alt={description}
        className="h-[30px] w-[36px] !rounded object-cover object-center"
      />
    </Button>
  );
};
